import { cx } from '@/utils/cx'
import { Button, DocumentCheckbox, Header } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import PrivacyPolicy from '@assets/privacy_policy.pdf'
import PrivacyPolicyDe from '@assets/privacy_policy_de.pdf'
import { StoreContext } from '@store/Root.store'
import { actionReport } from '@methods/actionReport'
import { getChecksumSha256FromFile } from '@methods/checksumSha256'
import { devLog } from '@methods/devLog'
import { DTPInfoGraph } from './DTPInfoGraph'
import { CheckedEvent } from '@/types/generic'

export const DTPInfoPage = observer(() => {
  const store = useContext(StoreContext)

  const { context } = store.ScenarioState
  const { isMobile } = store.AppState
  const { language } = store.TranslationsState
  const { dtpInfoPage: trans, generalConditionsPage: generalConditionsTrans } =
    store.TranslationsState.translationsNew

  const [idData, setIdData] = useState(false)
  const [signed, setSigned] = useState(false)

  useEffect(() => {
    if (context?.termsAndConditionsPresent) {
      store.ScenarioState.nextPage()
    }
  }, [])

  const handleProceed = async () => {
    try {
      store.ScenarioState.nextPage()
    } catch (e) {
      devLog(e)
    }
  }

  const handleIdData = ({ checked: value }: CheckedEvent) => {
    setIdData(value)

    if (value) {
      actionReport({
        type: 'event.onboarding-web.consent.CONSENT_CHECKED',
        payload: { documentType: 'OPEN_BANKING', isRequired: true },
      })
    } else {
      actionReport({
        type: 'event.onboarding-web.consent.CONSENT_UNCHECKED',
        payload: { documentType: 'OPEN_BANKING', isRequired: true },
      })
    }
  }

  useEffect(() => {
    async function handleSignedConsents() {
      if (idData === true) {
        const hash = await getChecksumSha256FromFile(
          language === 'de' ? PrivacyPolicyDe : PrivacyPolicy,
          'application/pdf'
        )
        setSigned(true)
        actionReport({
          type: 'event.onboarding-web.consent.CONSENT_ACCEPTED',
          payload: {
            fileName: language === 'de' ? 'privacy_policy_de.pdf' : 'privacy_policy.pdf',
            fileHash: hash,
            consentText: trans.idData,
          },
        })
      } else {
        setSigned(false)
      }
    }

    handleSignedConsents()
  }, [idData])

  return (
    <div className={cx('page-container', 'mobile-m-0', 'mobile-p-14-40')}>
      <Header>{trans.header}</Header>

      <div className="generic__micropayment-info-content">{trans.content}</div>

      <div className="generic__micropayment-info-graph">
        <DTPInfoGraph />
      </div>

      <div className="generic__micropayment-info-content">{trans.openBanking}</div>

      <div className="dtp__divider" />

      <DocumentCheckbox
        inputName="id-data"
        description={trans.idData}
        externalUrl={language === 'de' ? PrivacyPolicyDe : PrivacyPolicy}
        handleDecision={handleIdData}
        value={idData}
        goToDocumentLabel={generalConditionsTrans.goToDocument}
      />

      {isMobile ? <div className="dtp__dtp-general-conditions-spacer-mobile" /> : <></>}
      <div className="layout__content-container-bottom-fixed dtp__content-bottom-border">
        {!isMobile ? <div className="layout__content-container-bottom-left" /> : <></>}
        <Button id="btn-proceed" onClick={handleProceed} disabled={!signed}>
          <span className="generic__button-text">{trans.proceed}</span>
        </Button>
      </div>
    </div>
  )
})
